import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { AcademyHighlightService } from 'src/app/services/academy-highlight.service';
import { AcademyTopPlayersService } from 'src/app/services/academy-top-players.service';
import { AcademyCourtService } from 'src/app/services/academyCourt.service';
import { AcademybranchesService } from 'src/app/services/academybranches.service';
import { AcademycoachesService } from 'src/app/services/academycoaches.service';
import { AcademyprofileService } from 'src/app/services/academyprofile.service';
import { AcademysliderService } from 'src/app/services/academyslider.service';
import { environment } from 'src/environments/environment';
import { PhotoService } from '../../../demo/service/photoservice';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ReviewsService } from 'src/app/services/reviews.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import * as moment from 'moment';
@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  providers: [MessageService]
})

export class ViewComponent implements OnInit {
  reviewForm: FormGroup;
  reviewModalPopup: boolean = false;
  displayBasic: boolean | undefined;
  rating: number = 0;
  images: any[] | undefined;
  visible: boolean = false;
  id: any;
  item: any;
  academyname: any;
  foundedyear: any;
  description: any;
  mobilenumber: any;
  email: any;
  website: any;
  address: any;
  imageprofile: any;
  location: any;
  profileimage: any;
  loading: boolean;
  highlightlist: any = [];
  errorMessage = '';
  public disabled: boolean = false;
  playerlist: any = [];
  courtlist: any = [];
  branchlist: any = [];
  coachData: any = [];
  sliderData: any = [];
  sliderImages: any = [];
  totalcourt = 0;
  totalplayers: any;
  totalcoach: any;
  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  public Highlights_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    navigation: false,
    mousewheel: false,
    slidesPerView: 'auto',
    // pagination: {
    //     el: ".swiper-pagination",
    //     dynamicBullets: true,
    // },
    // navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  public slider_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    // pagination: {
    //   el: ".swiper-pagination",
    //   dynamicBullets: true,
    // },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      992: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      1200: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  };
  public topplayer_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: false,
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false
    // },
    mousewheel: false,
    slidesPerView: 'auto',
    // pagination: {
    //     el: ".swiper-pagination",
    //     dynamicBullets: true,
    // },
    // navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 5
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    // pagination: {
    //   el: ".swiper-pagination",
    //   dynamicBullets: true,
    // },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  };
  public branch_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    // pagination: {
    //   el: ".swiper-pagination",
    //   dynamicBullets: true,
    // },
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 4,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  };
  public Coaches_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    // pagination: {
    //   el: ".swiper-pagination",
    //   dynamicBullets: true,
    // },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  };
  public courtTypeList = environment.courtTypeList;
  public beginnerMorning: string;
  public beginnerEvening: string;
  public intermediateMorning: string;
  public intermediateEvening: string;
  public advanceMorning: string;
  public advanceEvening: string;

  public isSunday: boolean = false;
  public isMonday: boolean = false;
  public isTuesday: boolean = false;
  public isWednesday: boolean = false;
  public isThursday: boolean = false;
  public isFriday: boolean = false;
  public isSaturday: boolean = false;
  public showPdf: boolean = false;
  public submitted: boolean = false;
  public showRatingError: boolean = false;
  public academyFeesDoc: String;
  public loggedInAcademy;
  public loggedInAcademyUserId;
  private lazyLoadEvent: LazyLoadEvent;
  reviewsList: any;
  totalRecords: any;
  totalRating: number = 0;
  oneStar: number;
  twoStar: number;
  threeStar: number;
  fourStar: number;
  fiveStar: number;
  userId: any;
  isLogin: boolean;
  isAcademy: boolean;
  public pageNumber: number = 1;
  public reviewsListArray: any = [];
  public tempReviewsList: any = [];
  downloadFlg: boolean;
  public showWriteReview: boolean = false;
  constructor(private route: ActivatedRoute, private photoService: PhotoService, private profileservice: AcademyprofileService, private highlightservice: AcademyHighlightService, private playerservice: AcademyTopPlayersService, private academyCourtService: AcademyCourtService, private branchservice: AcademybranchesService, private coachservice: AcademycoachesService, private sliderservice: AcademysliderService, private formBuilder: FormBuilder, private reviewsService: ReviewsService, private tokenStorageService: TokenStorageService, private messageService: MessageService, private tournamentsService: TournamentsService,) { }

  ngOnInit(): void {
    this.photoService.getImages().then((images) => (this.images = images));
    this.reviewForm = this.formBuilder.group({
      comments: ['', Validators.required],
    }, { updateOn: "blur" });
    this.id = this.route.snapshot.paramMap.get('id');
    this.loggedInAcademy = this.tokenStorageService.getUser();
    if (this.loggedInAcademy?.userdata != undefined) {
      this.userId = this.loggedInAcademy.userdata.id;
      this.isLogin = true;
      this.getMyTournamentList();
      if (this.loggedInAcademy?.userdata.rolename == "academy") {
        this.isAcademy = true;
      } else {
        this.isAcademy = false;
      }
    } else {
      this.isLogin = false;
    }
    this.loggedInAcademyUserId = this.loggedInAcademy.userdata?.id;

    this.getacademydetails(this.id);
    this.loadhightlightlist();
    this.loadplayerlist();
    this.loadCourt();
    this.loadbranch();
    this.loadcoach();
    this.loadSlider();
    this.getReviews(this.lazyLoadEvent);
  }
  public firstDay;
  public lastDay;
  getacademydetails(id) {

    this.profileservice.getacademydetails(id).subscribe(res => {
      this.item = res;
      //console.log("xxxx", res);
      this.academyname = res.name;
      this.foundedyear = res.foundeyear;
      this.description = res.description;
      this.mobilenumber = res.mobileNumber;
      this.email = res.email;
      this.website = res.websiteurl;
      this.location = res.address;
      this.isSunday = res.sunday;
      this.isMonday = res.monday;
      this.isTuesday = res.tuesday;
      this.isWednesday = res.wednesday;
      this.isThursday = res.thursday;
      this.isFriday = res.friday;
      this.isSaturday = res.saturday;
      if (res.academyFees != undefined) {
        this.showPdf = true;
        this.academyFeesDoc = res.academyFees;
      } else {
        this.showPdf = false;
      }
      this.beginnerMorning = res.beginnerMorning;
      this.beginnerEvening = res.beginnerEvening;
      this.intermediateMorning = res.intermediateMorning;
      this.intermediateEvening = res.intermediateEvening;
      this.advanceMorning = res.advanceMorning;
      this.advanceEvening = res.advanceEvening;
      //this.imageprofile = res.academypic[0]['image_src'];
      this.imageprofile = res.academypic;
      if (res.noofHard > 0) {
        this.totalcourt = this.totalcourt + res.noofHard;
      }
      if (res.noofclay > 0) {
        this.totalcourt = this.totalcourt + res.noofclay;
      }
      if (res.noofgrass > 0) {
        this.totalcourt = this.totalcourt + res.noofgrass;
      }
      this.beginnerMorning = res.beginnerMorning;
      this.beginnerEvening = res.beginnerEvening;
      this.intermediateMorning = res.intermediateMorning;
      this.intermediateEvening = res.intermediateEvening;
      this.advanceMorning = res.advanceMorning;
      this.advanceEvening = res.advanceEvening;
    })
  }
  // loadslider() {
  //   var query = "?filterByDisable=false&filterByAcademyId=" + this.id;
  //   this.sliderservice.getAcademyslderList(query).subscribe(data => {
  //     this.loading = false;
  //     this.sliderData = data.data.items;
  //     this.sliderData.forEach((element) => {
  //       this.sliderImages = element;
  //     })
  //   },
  //     err => {
  //       this.errorMessage = err.error.message;
  //     });
  // }
  get f() {
    return this.reviewForm.controls;
  }
  loadcoach() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.id;
    this.coachservice.getAcademyCoaches(query).subscribe(data => {
      this.loading = false;
      this.coachData = data.data.items;
      this.totalcoach = data.data.totalCount;
    },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadbranch() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.id;
    this.branchservice.getAcademyBranches(query).subscribe(
      data => {
        this.loading = false;
        this.branchlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadhightlightlist() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.id;
    this.highlightservice.getAcademyHighlightList(query).subscribe(
      data => {
        this.loading = false;
        this.highlightlist = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadplayerlist() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.id;
    this.playerservice.getAcademyTopPlayers(query).subscribe(
      data => {
        this.loading = false;
        this.playerlist = data.data.items;
        this.playerlist.forEach(dt => {
          console.log(typeof dt.youtubeUrl)
        });
        this.totalplayers = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadCourt() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.id;
    this.academyCourtService.getAcademyCourtList(query).subscribe(
      data => {
        this.loading = false;
        if (data.data.items.length > 0) {
          this.courtlist = data.data.items;
          this.courtlist.forEach(dt => {
            let tmp = this.courtTypeList.find(o => o.value === dt.courtType);

            if (tmp != undefined) {
              dt.court = tmp.label;
            } else {
              dt.court = '';
            }
          })
        }
        // this.totalcourt = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  loadSlider() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.id;
    this.sliderservice.getAcademyslderList(query).subscribe(data => {
      this.loading = false;
      this.sliderData = data.data.items;
      if (this.sliderData.length > 0) {
        if (this.sliderData[0]['slider_image']) {
          this.sliderImages = this.sliderData[0]['slider_image'];
        }
      }
    },
      err => {
        this.errorMessage = err.error.message;
      });
  }


  public onIndexChange(index: number): void {
  }

  public onSwiperEvent(event: string): void {
  }
  public playerDescription: string;
  public playername;
  public openDialog(player) {
    this.playername = player.playerName;
    this.playerDescription = player.description;
    console.log(this.playerDescription);
    this.visible = true;
  }
  public showHighlightImg = "";
  public openHightlightImage(highlight) {
    this.displayBasic = true
    this.showHighlightImg = highlight.image
  }

  public openCourtImage(court) {
    this.displayBasic = true
    this.showHighlightImg = court.image
  }
  @HostListener('window:keyup.esc', ['$event']) w(e: KeyboardEvent) {
    this.displayBasic = false;
  }
  reviewModal() {
    if (this.isLogin) {
      this.reviewModalPopup = true;
      this.rating = 0;
      this.submitted = false;
      this.showRatingError = false;
      this.reviewForm.reset();
    } else {
      return
    }
  }
  onSelectRating() {
    this.showRatingError = false;
  }
  onReviewSubmit() {
    this.submitted = true;
    if (this.rating === 0) {
      this.showRatingError = true;
      return;
    }
    // stop here if form is invalid
    if (this.reviewForm.invalid) {
      this.showRatingError = false;
      return;
    }
    let reviewData = this.reviewForm.value;
    reviewData['rating'] = this.rating;
    reviewData['academyId'] = this.id;
    reviewData['userId'] = this.loggedInAcademyUserId;
    reviewData['status'] = true;
    reviewData['disable'] = false;
    this.reviewsService.addReviews(reviewData).subscribe(
      res => {
        this.reviewModalPopup = false;
        this.rating = 0;
        this.submitted = false;
        this.reviewForm.reset();
        this.messageService.add({ key: 'toastMsg', severity: 'success', summary: 'Success', detail: 'Review submitted.', life: 3000 });
        this.reviewsList = [];
        this.pageNumber = 1;
        this.getReviews(this.lazyLoadEvent);
      },
      err => {
        this.messageService.add({ key: 'toastMsg', severity: 'error', summary: 'Error', detail: 'System error, Please try again.', life: 3000 });
      }
    );
  }
  getReviews(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let params = "";
    let rows = 10;
    let query = "?filterByDisable=false&filterByStatus=true";
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        this.pageNumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        this.pageNumber = (event.first / event.rows) + 1;
      } else {
        this.pageNumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    query += "&pageSize=" + rows + "&pageNumber=" + this.pageNumber + params;
    query += "&filterByAcademyId=" + this.id;
    this.reviewsListArray = [];
    this.reviewsListArray = Object.assign([], this.reviewsList);
    this.reviewsService.getReviewsList(query).subscribe(
      async data => {
        this.loading = false;
        this.tempReviewsList = data.data.items;
        this.reviewsList = [...this.reviewsListArray, ...this.tempReviewsList];
        this.totalRecords = data.data.totalCount;
        let reviewCountGroup = data.reviewCountGroup;
        let oneStarCount = 0;
        let twoStarCount = 0;
        let threeStarCount = 0;
        let fourStarCount = 0;
        let fiveStarCount = 0;
        let oneStar = 0;
        let twoStar = 0;
        let threeStar = 0;
        let fourStar = 0;
        let fiveStar = 0;
        if (reviewCountGroup.length > 0) {
          reviewCountGroup.forEach(element => {
            if (element._id === environment.rating[0]) {
              oneStarCount = element.count;
              oneStar = element.sum;
            }
            if (element._id === environment.rating[1]) {
              twoStarCount = element.count;
              twoStar = element.sum;
            }
            if (element._id === environment.rating[2]) {
              threeStarCount = element.count;
              threeStar = element.sum;
            }
            if (element._id === environment.rating[3]) {
              fourStarCount = element.count;
              fourStar = element.sum;
            }
            if (element._id === environment.rating[4]) {
              fiveStarCount = element.count;
              fiveStar = element.sum;
            }
          });
        }
        let totalRating = Number(oneStar) + Number(twoStar) + Number(threeStar) + Number(fourStar) + Number(fiveStar);
        if (Number(totalRating) > 0) {
          this.totalRating = Number(totalRating) / Number(this.totalRecords);
          this.oneStar = (Number(oneStarCount) / this.totalRecords) * Number(100);
          this.twoStar = (Number(twoStarCount) / this.totalRecords) * Number(100);
          this.threeStar = (Number(threeStarCount) / this.totalRecords) * Number(100);
          this.fourStar = (Number(fourStarCount) / this.totalRecords) * Number(100);
          this.fiveStar = (Number(fiveStarCount) / this.totalRecords) * Number(100);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    )
  }
  getMyTournamentList() {
    var query = "?filterByDisabled=false&filterByUserId=" + this.userId;
    this.tournamentsService.getPlayerTournamentList(query).subscribe(
      data => {
        this.loading = false;
        let myTournamentList = data.data.items;
        if (myTournamentList.length > 0) {
          let tournamentEntryExist = myTournamentList.filter((a: { academyId: any; }) => { return a.academyId === this.id });
          if (tournamentEntryExist.length > 0) {
            this.showWriteReview = true;
          }
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  onClickLoadMore() {
    this.pageNumber++;
    this.getReviews(this.lazyLoadEvent);
  }
}
